import { Component, HostListener, Injectable, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthFactoryService } from '../auth/authFactory.service';
import { ActionTypeText, LOCALSTORAGEVARS, OptionType } from '../core/enums/enums';
import { ReportLogService } from '../shared/services/report-log.service';
import { SettingsService } from '../settings/services/settings.service';
import { Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-inactivity-counter',
  templateUrl: './inactivity.component.html',
  styleUrls: ['./inactivity.component.scss']
})
export class InactivityCounter implements OnInit, OnDestroy {
  subscriptions = new Subscription();
  private readonly oneMinute = 60000; //one minute on miliseconds
  private readonly minutesToShowAlert = 10; //ten minutes to show alert
  private readonly minutesToCloseSession = 12; //twelve minutes to close session automatically
  private timerInterval: any;
  logoutTimeoutEnabledSettings: boolean;
  wantToCloseSession: boolean = false;
  inactivityMinutes: number = 0;
  showSessionAlert: boolean = false;

  constructor(
    private router: Router,
    private reportLog: ReportLogService,
    private authFactoryService: AuthFactoryService,
    private settingsService: SettingsService
  ) {}

  ngOnInit() {
    this.subscriptions.add(
      this.settingsService.getClientSettings().subscribe((settings: any) => {
        this.logoutTimeoutEnabledSettings = settings?.logoutTimeoutEnabled;
      })
    );

    this.onActivity();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  @HostListener('window:click')
  @HostListener('window:mousemove')
  @HostListener('window:keydown')
  onActivity() {
    if (this.logoutTimeoutEnabledSettings) {
      if (this.isDashboard()) {
        this.stopTimer();
      }
      if (!this.isDashboard() && !this.showSessionAlert) {
        this.stopTimer();
        this.startTimer();
      }
    }
  }

  isDashboard() {
    return this.router.url.includes(OptionType.Dashboard);
  }

  startTimer() {
    this.timerInterval = setInterval(() => {
      this.inactivityMinutes = this.inactivityMinutes + 1;
      if (this.inactivityMinutes < this.minutesToShowAlert) {
        this.closeSessionAlert();
      }
      if (this.inactivityMinutes === this.minutesToShowAlert) {
        this.openSessionAlert();
      }
      if (this.inactivityMinutes === this.minutesToCloseSession) {
        this.closeSession();
      }
      if (this.inactivityMinutes > this.minutesToCloseSession) {
        this.closeSessionAlert();
        this.stopTimer();
      }
    }, this.oneMinute);
  }

  openSessionAlert() {
    this.showSessionAlert = true;
  }

  closeSessionAlert() {
    this.showSessionAlert = false;
  }

  stopTimer() {
    clearInterval(this.timerInterval);
    this.closeSessionAlert();
    this.inactivityMinutes = 0;
  }

  checkedCloseSession(event: boolean) {
    this.wantToCloseSession = event;
  }

  closeSession() {
    localStorage.removeItem(LOCALSTORAGEVARS.FormExchanges);
    this.reportLog.TimeOut(ActionTypeText.NA);
    this.closeSessionAlert();
    this.stopTimer();
    this.authFactoryService.logoff();
  }
}
